import is from '@/utils/is';
import { convertToString } from './string';

export const isSessionStorageExists = () =>
  is.client() && typeof Storage !== 'undefined' && typeof sessionStorage !== 'undefined';

class SessionStorage {
  static get = (key: string) => {
    if (isSessionStorageExists()) {
      return window.sessionStorage.getItem(key) ?? null;
    }
    return null;
  };

  static set = (key: string, value: any) => {
    if (isSessionStorageExists()) {
      window.sessionStorage.setItem(key, convertToString(value));
    }
  };

  static remove = (key: string) => {
    if (isSessionStorageExists() && this.get(key)) {
      return window.sessionStorage.removeItem(key);
    }
  };
}

export default SessionStorage;
